import { ajax, ajxOptions, AxiosResponse } from './ajax/axiosAjax'
import Tips from './ajax/tips'
import { handlerToken } from './tools'

interface enhanceOpt extends ajxOptions {
  error?: boolean | string
  success?: boolean | string
  [key: string]: any // 任意扩展参数
}
// 业务接口
async function BaseApi(
  opt: enhanceOpt,
  {
    prefix = '',
    codeNum = 0,
    codeField = 'codeField',
    msgField = 'message',
    successField = 'success',
  } = {},
) {
  const error = opt.error ?? true // 错误提醒
  const success = opt.success ?? false // 成功提醒
  //opt.baseURL = ''
  opt.url = handlerToken(prefix + opt.url)
  try {
    const result = (await ajax(opt)) as AxiosResponse
    const { data } = result as AxiosResponse
    const code = result.data[codeField]
    const successdata = result.data[successField]
    const message = result.data[msgField]

    if (!('success' in result.data)) {
      // 有的接口根本不返回success,因此这边直接返回Promise.resolve
      return Promise.resolve(data)
    }
    if (successdata) {
      // console.log(1111)
      success && Tips.success({ msg: success !== true ? success : message ? message : '成功' })
      return Promise.resolve(data)
    } else {
      // console.log(22222)
      error && Tips.error({ msg: error !== true ? error : message ? message : '失败' })

      return Promise.reject(message)
    }
  } catch (e: any) {
    // console.log(333333)
    const message = e[msgField]
    error && Tips.error({ msg: error !== true ? error : message ? message : '失败' })

    return Promise.reject(e)
  }
}
export { BaseApi, enhanceOpt }
